var SiteHeader = /** @class */ (function () {
    function SiteHeader() {
        var _this = this;
        this.burgerTrigger = undefined;
        this.navMenu = undefined;
        this.siteHeader = undefined;
        this.hasBanner = false;
        this.burgerTrigger = document.getElementsByClassName("site-header__menu-trigger")[0];
        this.burgerTrigger.addEventListener("click", function () { return _this.toggleBurger(); });
        this.navMenu = document.getElementsByClassName("site-header__menu")[0];
        this.siteHeader = document.getElementsByClassName("site-header")[0];
        this.prevScrollpos = window.scrollY;
        this.hasBanner = this.siteHeader.classList.contains("with-banner");
        window.addEventListener("scroll", function (event) { return _this.handleScroll(); });
        // this.siteHeader.style.display = "none";
        // setTimeout(() => { if (this.siteHeader) { this.siteHeader.style.display = "block" } }, 100)
    }
    SiteHeader.prototype.toggleBurger = function () {
        var _this = this;
        var _a;
        if (this.burgerTrigger)
            this.burgerTrigger.classList.toggle("is-active");
        if (this.navMenu)
            this.navMenu.classList.toggle("site-header__menu--active");
        if ((_a = this.burgerTrigger) === null || _a === void 0 ? void 0 : _a.classList.contains("is-active")) {
            setTimeout(function () {
                document.addEventListener("click", function () { return _this.closeBurger(); }, {
                    once: true
                });
            }, 100);
        }
    };
    SiteHeader.prototype.closeBurger = function () {
        if (this.burgerTrigger)
            this.burgerTrigger.classList.remove("is-active");
        if (this.navMenu)
            this.navMenu.classList.remove("site-header__menu--active");
    };
    SiteHeader.prototype.handleScroll = function () {
        var currentScrollpos = window.scrollY;
        // Ensure that the site header element exists
        if (!this.siteHeader)
            return;
        // if (this.hasBanner) {
        //   // When scrolled past 400px, make the header stick to the top
        //   const top = Math.max(0, 600 - currentScrollpos)
        //   if (top === 0 && Math.abs(this.prevScrollpos - currentScrollpos) <= 100) {
        //     return;
        //   }
        //   if (currentScrollpos <= 800) {
        //     this.siteHeader.style.transition = "top 0s";
        //   } else {
        //     this.siteHeader.style.transition = "top 1s";
        //   }
        //   if (this.prevScrollpos >= currentScrollpos || currentScrollpos <= 800) {
        //     this.siteHeader.style.top = `${top}px`; // Show the header
        //   } else {
        //     this.siteHeader.style.top = "-5rem"; // Hide the header by moving it offscreen
        //   }
        // } else {
        // // Handle hiding and showing the header on scroll beyond a threshold (optional)
        if (Math.abs(this.prevScrollpos - currentScrollpos) <= 100)
            return;
        if (this.prevScrollpos > currentScrollpos) {
            this.siteHeader.style.top = "0"; // Show the header
        }
        else {
            if (currentScrollpos < 500)
                return;
            this.siteHeader.style.top = "-5rem"; // Hide the header by moving it offscreen
        }
        // }
        // Update the previous scroll position for the next scroll event
        this.prevScrollpos = currentScrollpos;
    };
    return SiteHeader;
}());
export { SiteHeader };
